// @generated by protobuf-ts 2.11.1 with parameter generate_dependencies,ts_nocheck
// @generated from protobuf file "agency/billing/v1/billing.proto" (package "agency.billing.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
import type { BinaryWriteOptions } from "@protobuf-ts/runtime";
import type { IBinaryWriter } from "@protobuf-ts/runtime";
import { WireType } from "@protobuf-ts/runtime";
import type { BinaryReadOptions } from "@protobuf-ts/runtime";
import type { IBinaryReader } from "@protobuf-ts/runtime";
import { UnknownFieldHandler } from "@protobuf-ts/runtime";
import type { PartialMessage } from "@protobuf-ts/runtime";
import { reflectionMergePartial } from "@protobuf-ts/runtime";
import { MessageType } from "@protobuf-ts/runtime";
import { Timestamp } from "../../../google/protobuf/timestamp";
/**
 * Money represents a monetary amount with currency code.
 * Replaces google.type.Money to avoid googleapis dependency.
 *
 * @generated from protobuf message agency.billing.v1.Money
 */
export interface Money {
    /**
     * currency_code is the 3-letter ISO 4217 currency code (e.g., "USD", "EUR").
     *
     * @generated from protobuf field: string currency_code = 1
     */
    currencyCode: string;
    /**
     * units is the whole units of the amount (e.g., dollars).
     *
     * @generated from protobuf field: int64 units = 2
     */
    units: bigint;
    /**
     * nanos is the fractional units (e.g., cents) in the range [-999,999,999, +999,999,999].
     * Must have the same sign as units (or be zero).
     *
     * @generated from protobuf field: int32 nanos = 3
     */
    nanos: number;
}
/**
 * QuotaSplitConfig defines the split percentages for BILL_SPLIT policy.
 *
 * @generated from protobuf message agency.billing.v1.QuotaSplitConfig
 */
export interface QuotaSplitConfig {
    /**
     * initiator_percentage is the percentage billed to the initiator (0.0-1.0).
     *
     * @generated from protobuf field: float initiator_percentage = 1
     */
    initiatorPercentage: number;
    /**
     * delegate_percentage is the percentage billed to the delegate (0.0-1.0).
     *
     * @generated from protobuf field: float delegate_percentage = 2
     */
    delegatePercentage: number;
}
/**
 * CostBreakdown provides detailed cost attribution.
 *
 * @generated from protobuf message agency.billing.v1.CostBreakdown
 */
export interface CostBreakdown {
    /**
     * llm_input_tokens_cost is the cost for LLM input tokens.
     *
     * @generated from protobuf field: agency.billing.v1.Money llm_input_tokens_cost = 1
     */
    llmInputTokensCost?: Money;
    /**
     * llm_output_tokens_cost is the cost for LLM output tokens.
     *
     * @generated from protobuf field: agency.billing.v1.Money llm_output_tokens_cost = 2
     */
    llmOutputTokensCost?: Money;
    /**
     * llm_input_tokens is the count of LLM input tokens.
     *
     * @generated from protobuf field: int64 llm_input_tokens = 3
     */
    llmInputTokens: bigint;
    /**
     * llm_output_tokens is the count of LLM output tokens.
     *
     * @generated from protobuf field: int64 llm_output_tokens = 4
     */
    llmOutputTokens: bigint;
    /**
     * cache_read_tokens is the count of cache read tokens.
     *
     * @generated from protobuf field: int64 cache_read_tokens = 5
     */
    cacheReadTokens: bigint;
    /**
     * cache_read_cost is the cost for cache reads.
     *
     * @generated from protobuf field: agency.billing.v1.Money cache_read_cost = 6
     */
    cacheReadCost?: Money;
    /**
     * cache_write_tokens is the count of cache write tokens.
     *
     * @generated from protobuf field: int64 cache_write_tokens = 7
     */
    cacheWriteTokens: bigint;
    /**
     * cache_write_cost is the cost for cache writes.
     *
     * @generated from protobuf field: agency.billing.v1.Money cache_write_cost = 8
     */
    cacheWriteCost?: Money;
    /**
     * tool_calls_count is the number of tool calls.
     *
     * @generated from protobuf field: int32 tool_calls_count = 9
     */
    toolCallsCount: number;
    /**
     * tool_calls_cost is the cost for tool executions.
     *
     * @generated from protobuf field: agency.billing.v1.Money tool_calls_cost = 10
     */
    toolCallsCost?: Money;
    /**
     * sub_agent_cost is the cost attributed to sub-agent delegation.
     *
     * @generated from protobuf field: agency.billing.v1.Money sub_agent_cost = 11
     */
    subAgentCost?: Money;
    /**
     * sub_agent_count is the number of sub-agents spawned.
     *
     * @generated from protobuf field: int32 sub_agent_count = 12
     */
    subAgentCount: number;
}
/**
 * BillingEvent records a billable usage event.
 *
 * @generated from protobuf message agency.billing.v1.BillingEvent
 */
export interface BillingEvent {
    /**
     * tenant is the tenant identifier.
     *
     * @generated from protobuf field: string tenant = 1
     */
    tenant: string;
    /**
     * workspace is the workspace identifier.
     *
     * @generated from protobuf field: string workspace = 2
     */
    workspace: string;
    /**
     * session_id is the session that generated this event.
     *
     * @generated from protobuf field: string session_id = 3
     */
    sessionId: string;
    /**
     * tokens_consumed is the token usage.
     *
     * @generated from protobuf field: int64 tokens_consumed = 4
     */
    tokensConsumed: bigint;
    /**
     * cost is the monetary cost for this event.
     *
     * @generated from protobuf field: agency.billing.v1.Money cost = 5
     */
    cost?: Money;
    /**
     * attribution is the billing policy applied.
     *
     * @generated from protobuf field: agency.billing.v1.QuotaBillingPolicy attribution = 6
     */
    attribution: QuotaBillingPolicy;
    /**
     * timestamp is when the billable event occurred.
     *
     * @generated from protobuf field: google.protobuf.Timestamp timestamp = 7
     */
    timestamp?: Timestamp;
    /**
     * operation_type describes the billable operation (e.g., "llm_call", "tool_execution").
     *
     * @generated from protobuf field: string operation_type = 8
     */
    operationType: string;
    /**
     * parent_session_id is the parent session (if this is a sub-agent).
     *
     * @generated from protobuf field: string parent_session_id = 9
     */
    parentSessionId: string;
    /**
     * initiator_workspace is the workspace that initiated the work (for BILL_SPLIT).
     *
     * @generated from protobuf field: string initiator_workspace = 10
     */
    initiatorWorkspace: string;
    /**
     * split_config contains split percentages (if attribution is BILL_SPLIT).
     *
     * @generated from protobuf field: agency.billing.v1.QuotaSplitConfig split_config = 11
     */
    splitConfig?: QuotaSplitConfig;
    /**
     * model_id is the LLM model used (if applicable).
     *
     * @generated from protobuf field: string model_id = 12
     */
    modelId: string;
    /**
     * tool_name is the tool executed (if applicable).
     *
     * @generated from protobuf field: string tool_name = 13
     */
    toolName: string;
    /**
     * cost_breakdown provides detailed cost attribution.
     *
     * @generated from protobuf field: agency.billing.v1.CostBreakdown cost_breakdown = 14
     */
    costBreakdown?: CostBreakdown;
}
/**
 * TierConfig maps a tier to quota and billing policies.
 *
 * @generated from protobuf message agency.billing.v1.TierConfig
 */
export interface TierConfig {
    /**
     * tier_id uniquely identifies the tier.
     *
     * @generated from protobuf field: string tier_id = 1
     */
    tierId: string;
    /**
     * name is the human-readable tier name.
     *
     * @generated from protobuf field: string name = 2
     */
    name: string;
    /**
     * token_limit is the total token budget.
     *
     * @generated from protobuf field: int64 token_limit = 3
     */
    tokenLimit: bigint;
    /**
     * refill_rate is tokens added per second.
     *
     * @generated from protobuf field: int64 refill_rate = 4
     */
    refillRate: bigint;
    /**
     * price_per_million_tokens is the cost per 1M tokens.
     *
     * @generated from protobuf field: agency.billing.v1.Money price_per_million_tokens = 5
     */
    pricePerMillionTokens?: Money;
    /**
     * billing_policy is the default billing attribution policy.
     *
     * @generated from protobuf field: agency.billing.v1.QuotaBillingPolicy billing_policy = 6
     */
    billingPolicy: QuotaBillingPolicy;
    /**
     * features are tier-specific feature flags.
     *
     * @generated from protobuf field: repeated string features = 7
     */
    features: string[];
    /**
     * max_concurrent_sessions is the concurrent session limit.
     *
     * @generated from protobuf field: int32 max_concurrent_sessions = 8
     */
    maxConcurrentSessions: number;
    /**
     * max_session_duration_seconds is the per-session time limit.
     *
     * @generated from protobuf field: int32 max_session_duration_seconds = 9
     */
    maxSessionDurationSeconds: number;
}
/**
 * SessionSpend tracks per-session usage for billing.
 *
 * @generated from protobuf message agency.billing.v1.SessionSpend
 */
export interface SessionSpend {
    /**
     * session_id uniquely identifies the session.
     *
     * @generated from protobuf field: string session_id = 1
     */
    sessionId: string;
    /**
     * tenant is the tenant identifier.
     *
     * @generated from protobuf field: string tenant = 2
     */
    tenant: string;
    /**
     * workspace is the workspace identifier.
     *
     * @generated from protobuf field: string workspace = 3
     */
    workspace: string;
    /**
     * tokens_consumed is the total token usage.
     *
     * @generated from protobuf field: int64 tokens_consumed = 4
     */
    tokensConsumed: bigint;
    /**
     * tool_calls is the total tool call count.
     *
     * @generated from protobuf field: int32 tool_calls = 5
     */
    toolCalls: number;
    /**
     * llm_calls is the total LLM call count.
     *
     * @generated from protobuf field: int32 llm_calls = 6
     */
    llmCalls: number;
    /**
     * estimated_cost is the approximate cost.
     *
     * @generated from protobuf field: agency.billing.v1.Money estimated_cost = 7
     */
    estimatedCost?: Money;
    /**
     * updated_at is the last update timestamp.
     *
     * @generated from protobuf field: google.protobuf.Timestamp updated_at = 8
     */
    updatedAt?: Timestamp;
    /**
     * started_at is when the session started.
     *
     * @generated from protobuf field: google.protobuf.Timestamp started_at = 9
     */
    startedAt?: Timestamp;
    /**
     * completed_at is when the session completed (if finished).
     *
     * @generated from protobuf field: google.protobuf.Timestamp completed_at = 10
     */
    completedAt?: Timestamp;
}
/**
 * WorkspaceUsageAggregate tracks workspace-level usage.
 *
 * @generated from protobuf message agency.billing.v1.WorkspaceUsageAggregate
 */
export interface WorkspaceUsageAggregate {
    /**
     * tenant is the tenant identifier.
     *
     * @generated from protobuf field: string tenant = 1
     */
    tenant: string;
    /**
     * workspace is the workspace identifier.
     *
     * @generated from protobuf field: string workspace = 2
     */
    workspace: string;
    /**
     * period_start is the start of the billing period.
     *
     * @generated from protobuf field: google.protobuf.Timestamp period_start = 3
     */
    periodStart?: Timestamp;
    /**
     * period_end is the end of the billing period.
     *
     * @generated from protobuf field: google.protobuf.Timestamp period_end = 4
     */
    periodEnd?: Timestamp;
    /**
     * total_tokens is the total token usage in this period.
     *
     * @generated from protobuf field: int64 total_tokens = 5
     */
    totalTokens: bigint;
    /**
     * total_sessions is the total session count.
     *
     * @generated from protobuf field: int32 total_sessions = 6
     */
    totalSessions: number;
    /**
     * total_tool_calls is the total tool call count.
     *
     * @generated from protobuf field: int32 total_tool_calls = 7
     */
    totalToolCalls: number;
    /**
     * total_cost is the total monetary cost.
     *
     * @generated from protobuf field: agency.billing.v1.Money total_cost = 8
     */
    totalCost?: Money;
    /**
     * updated_at is the last update timestamp.
     *
     * @generated from protobuf field: google.protobuf.Timestamp updated_at = 9
     */
    updatedAt?: Timestamp;
}
/**
 * TenantUsageAggregate tracks tenant-level usage.
 *
 * @generated from protobuf message agency.billing.v1.TenantUsageAggregate
 */
export interface TenantUsageAggregate {
    /**
     * tenant is the tenant identifier.
     *
     * @generated from protobuf field: string tenant = 1
     */
    tenant: string;
    /**
     * period_start is the start of the billing period.
     *
     * @generated from protobuf field: google.protobuf.Timestamp period_start = 2
     */
    periodStart?: Timestamp;
    /**
     * period_end is the end of the billing period.
     *
     * @generated from protobuf field: google.protobuf.Timestamp period_end = 3
     */
    periodEnd?: Timestamp;
    /**
     * total_tokens is the total token usage in this period.
     *
     * @generated from protobuf field: int64 total_tokens = 4
     */
    totalTokens: bigint;
    /**
     * total_workspaces is the count of active workspaces.
     *
     * @generated from protobuf field: int32 total_workspaces = 5
     */
    totalWorkspaces: number;
    /**
     * total_sessions is the total session count.
     *
     * @generated from protobuf field: int32 total_sessions = 6
     */
    totalSessions: number;
    /**
     * total_cost is the total monetary cost.
     *
     * @generated from protobuf field: agency.billing.v1.Money total_cost = 7
     */
    totalCost?: Money;
    /**
     * updated_at is the last update timestamp.
     *
     * @generated from protobuf field: google.protobuf.Timestamp updated_at = 8
     */
    updatedAt?: Timestamp;
}
/**
 * UsageRollup aggregates spend deltas into hierarchical rollups.
 *
 * @generated from protobuf message agency.billing.v1.UsageRollup
 */
export interface UsageRollup {
    /**
     * tenant is the tenant identifier.
     *
     * @generated from protobuf field: string tenant = 1
     */
    tenant: string;
    /**
     * workspace is the workspace identifier.
     *
     * @generated from protobuf field: string workspace = 2
     */
    workspace: string;
    /**
     * session_id is the session (if session-level rollup).
     *
     * @generated from protobuf field: string session_id = 3
     */
    sessionId: string;
    /**
     * rollup_level indicates the aggregation level.
     *
     * @generated from protobuf field: agency.billing.v1.RollupLevel rollup_level = 4
     */
    rollupLevel: RollupLevel;
    /**
     * token_delta is the token usage change.
     *
     * @generated from protobuf field: int64 token_delta = 5
     */
    tokenDelta: bigint;
    /**
     * cost_delta is the cost change.
     *
     * @generated from protobuf field: agency.billing.v1.Money cost_delta = 6
     */
    costDelta?: Money;
    /**
     * operation_count is the number of operations in this rollup.
     *
     * @generated from protobuf field: int32 operation_count = 7
     */
    operationCount: number;
    /**
     * period_start is the rollup period start.
     *
     * @generated from protobuf field: google.protobuf.Timestamp period_start = 8
     */
    periodStart?: Timestamp;
    /**
     * period_end is the rollup period end.
     *
     * @generated from protobuf field: google.protobuf.Timestamp period_end = 9
     */
    periodEnd?: Timestamp;
    /**
     * cost_breakdown provides detailed cost attribution.
     *
     * @generated from protobuf field: agency.billing.v1.CostBreakdown cost_breakdown = 10
     */
    costBreakdown?: CostBreakdown;
}
/**
 * TierResolutionRequest requests tier lookup for a tenant.
 *
 * @generated from protobuf message agency.billing.v1.TierResolutionRequest
 */
export interface TierResolutionRequest {
    /**
     * tenant is the tenant identifier.
     *
     * @generated from protobuf field: string tenant = 1
     */
    tenant: string;
    /**
     * workspace is the workspace identifier (optional).
     *
     * @generated from protobuf field: string workspace = 2
     */
    workspace: string;
}
/**
 * TierResolutionResponse returns the tier configuration.
 *
 * @generated from protobuf message agency.billing.v1.TierResolutionResponse
 */
export interface TierResolutionResponse {
    /**
     * tier_config is the resolved tier configuration.
     *
     * @generated from protobuf field: agency.billing.v1.TierConfig tier_config = 1
     */
    tierConfig?: TierConfig;
    /**
     * tenant is the tenant this tier applies to.
     *
     * @generated from protobuf field: string tenant = 2
     */
    tenant: string;
    /**
     * resolved_at is when the resolution occurred.
     *
     * @generated from protobuf field: google.protobuf.Timestamp resolved_at = 3
     */
    resolvedAt?: Timestamp;
}
/**
 * CostAttributionRequest requests billing attribution for sub-agent work.
 *
 * @generated from protobuf message agency.billing.v1.CostAttributionRequest
 */
export interface CostAttributionRequest {
    /**
     * session_id is the session generating the cost.
     *
     * @generated from protobuf field: string session_id = 1
     */
    sessionId: string;
    /**
     * parent_session_id is the parent session (if sub-agent).
     *
     * @generated from protobuf field: string parent_session_id = 2
     */
    parentSessionId: string;
    /**
     * initiator_tenant is the tenant that initiated the work.
     *
     * @generated from protobuf field: string initiator_tenant = 3
     */
    initiatorTenant: string;
    /**
     * initiator_workspace is the workspace that initiated the work.
     *
     * @generated from protobuf field: string initiator_workspace = 4
     */
    initiatorWorkspace: string;
    /**
     * delegate_tenant is the tenant executing the work.
     *
     * @generated from protobuf field: string delegate_tenant = 5
     */
    delegateTenant: string;
    /**
     * delegate_workspace is the workspace executing the work.
     *
     * @generated from protobuf field: string delegate_workspace = 6
     */
    delegateWorkspace: string;
    /**
     * billing_policy is the attribution policy to apply.
     *
     * @generated from protobuf field: agency.billing.v1.QuotaBillingPolicy billing_policy = 7
     */
    billingPolicy: QuotaBillingPolicy;
    /**
     * split_config contains split percentages (if BILL_SPLIT).
     *
     * @generated from protobuf field: agency.billing.v1.QuotaSplitConfig split_config = 8
     */
    splitConfig?: QuotaSplitConfig;
    /**
     * cost is the total cost to attribute.
     *
     * @generated from protobuf field: agency.billing.v1.Money cost = 9
     */
    cost?: Money;
    /**
     * tokens_consumed is the token usage.
     *
     * @generated from protobuf field: int64 tokens_consumed = 10
     */
    tokensConsumed: bigint;
    /**
     * cost_breakdown provides detailed cost breakdown.
     *
     * @generated from protobuf field: agency.billing.v1.CostBreakdown cost_breakdown = 11
     */
    costBreakdown?: CostBreakdown;
}
/**
 * CostAttributionResponse returns the attributed billing events.
 *
 * @generated from protobuf message agency.billing.v1.CostAttributionResponse
 */
export interface CostAttributionResponse {
    /**
     * attributed_events are the billing events after attribution.
     *
     * @generated from protobuf field: repeated agency.billing.v1.BillingEvent attributed_events = 1
     */
    attributedEvents: BillingEvent[];
    /**
     * initiator_cost is the cost attributed to the initiator.
     *
     * @generated from protobuf field: agency.billing.v1.Money initiator_cost = 2
     */
    initiatorCost?: Money;
    /**
     * delegate_cost is the cost attributed to the delegate.
     *
     * @generated from protobuf field: agency.billing.v1.Money delegate_cost = 3
     */
    delegateCost?: Money;
    /**
     * policy_applied is the billing policy that was applied.
     *
     * @generated from protobuf field: agency.billing.v1.QuotaBillingPolicy policy_applied = 4
     */
    policyApplied: QuotaBillingPolicy;
    /**
     * attributed_at is when the attribution occurred.
     *
     * @generated from protobuf field: google.protobuf.Timestamp attributed_at = 5
     */
    attributedAt?: Timestamp;
}
/**
 * QuotaBillingPolicy determines how sub-agent costs are attributed.
 *
 * @generated from protobuf enum agency.billing.v1.QuotaBillingPolicy
 */
export enum QuotaBillingPolicy {
    /**
     * UNSPECIFIED is the zero value and should not be used.
     *
     * @generated from protobuf enum value: QUOTA_BILLING_POLICY_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * BILL_INITIATOR bills the workspace that spawned the parent session.
     *
     * @generated from protobuf enum value: QUOTA_BILLING_POLICY_BILL_INITIATOR = 1;
     */
    BILL_INITIATOR = 1,
    /**
     * BILL_DELEGATE bills the workspace whose work is being executed.
     *
     * @generated from protobuf enum value: QUOTA_BILLING_POLICY_BILL_DELEGATE = 2;
     */
    BILL_DELEGATE = 2,
    /**
     * BILL_SPLIT splits costs between initiator and delegate.
     *
     * @generated from protobuf enum value: QUOTA_BILLING_POLICY_BILL_SPLIT = 3;
     */
    BILL_SPLIT = 3
}
/**
 * RollupLevel defines the aggregation hierarchy.
 *
 * @generated from protobuf enum agency.billing.v1.RollupLevel
 */
export enum RollupLevel {
    /**
     * UNSPECIFIED is the zero value and should not be used.
     *
     * @generated from protobuf enum value: ROLLUP_LEVEL_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * SESSION is per-session aggregation.
     *
     * @generated from protobuf enum value: ROLLUP_LEVEL_SESSION = 1;
     */
    SESSION = 1,
    /**
     * WORKSPACE is per-workspace aggregation.
     *
     * @generated from protobuf enum value: ROLLUP_LEVEL_WORKSPACE = 2;
     */
    WORKSPACE = 2,
    /**
     * TENANT is per-tenant aggregation.
     *
     * @generated from protobuf enum value: ROLLUP_LEVEL_TENANT = 3;
     */
    TENANT = 3
}
// @generated message type with reflection information, may provide speed optimized methods
class Money$Type extends MessageType<Money> {
    constructor() {
        super("agency.billing.v1.Money", [
            { no: 1, name: "currency_code", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { len: "3", pattern: "^[A-Z]{3}$" } } } },
            { no: 2, name: "units", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 3, name: "nanos", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "buf.validate.field": { int32: { lte: 999999999, gte: -999999999 } } } }
        ]);
    }
    create(value?: PartialMessage<Money>): Money {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.currencyCode = "";
        message.units = 0n;
        message.nanos = 0;
        if (value !== undefined)
            reflectionMergePartial<Money>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Money): Money {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string currency_code */ 1:
                    message.currencyCode = reader.string();
                    break;
                case /* int64 units */ 2:
                    message.units = reader.int64().toBigInt();
                    break;
                case /* int32 nanos */ 3:
                    message.nanos = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: Money, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string currency_code = 1; */
        if (message.currencyCode !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.currencyCode);
        /* int64 units = 2; */
        if (message.units !== 0n)
            writer.tag(2, WireType.Varint).int64(message.units);
        /* int32 nanos = 3; */
        if (message.nanos !== 0)
            writer.tag(3, WireType.Varint).int32(message.nanos);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.billing.v1.Money
 */
export const Money = new Money$Type();
// @generated message type with reflection information, may provide speed optimized methods
class QuotaSplitConfig$Type extends MessageType<QuotaSplitConfig> {
    constructor() {
        super("agency.billing.v1.QuotaSplitConfig", [
            { no: 1, name: "initiator_percentage", kind: "scalar", T: 2 /*ScalarType.FLOAT*/, options: { "buf.validate.field": { float: { lte: 1, gte: 0 } } } },
            { no: 2, name: "delegate_percentage", kind: "scalar", T: 2 /*ScalarType.FLOAT*/, options: { "buf.validate.field": { float: { lte: 1, gte: 0 } } } }
        ]);
    }
    create(value?: PartialMessage<QuotaSplitConfig>): QuotaSplitConfig {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.initiatorPercentage = 0;
        message.delegatePercentage = 0;
        if (value !== undefined)
            reflectionMergePartial<QuotaSplitConfig>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: QuotaSplitConfig): QuotaSplitConfig {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* float initiator_percentage */ 1:
                    message.initiatorPercentage = reader.float();
                    break;
                case /* float delegate_percentage */ 2:
                    message.delegatePercentage = reader.float();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: QuotaSplitConfig, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* float initiator_percentage = 1; */
        if (message.initiatorPercentage !== 0)
            writer.tag(1, WireType.Bit32).float(message.initiatorPercentage);
        /* float delegate_percentage = 2; */
        if (message.delegatePercentage !== 0)
            writer.tag(2, WireType.Bit32).float(message.delegatePercentage);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.billing.v1.QuotaSplitConfig
 */
export const QuotaSplitConfig = new QuotaSplitConfig$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CostBreakdown$Type extends MessageType<CostBreakdown> {
    constructor() {
        super("agency.billing.v1.CostBreakdown", [
            { no: 1, name: "llm_input_tokens_cost", kind: "message", T: () => Money },
            { no: 2, name: "llm_output_tokens_cost", kind: "message", T: () => Money },
            { no: 3, name: "llm_input_tokens", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/, options: { "buf.validate.field": { int64: { gte: "0" } } } },
            { no: 4, name: "llm_output_tokens", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/, options: { "buf.validate.field": { int64: { gte: "0" } } } },
            { no: 5, name: "cache_read_tokens", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/, options: { "buf.validate.field": { int64: { gte: "0" } } } },
            { no: 6, name: "cache_read_cost", kind: "message", T: () => Money },
            { no: 7, name: "cache_write_tokens", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/, options: { "buf.validate.field": { int64: { gte: "0" } } } },
            { no: 8, name: "cache_write_cost", kind: "message", T: () => Money },
            { no: 9, name: "tool_calls_count", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "buf.validate.field": { int32: { gte: 0 } } } },
            { no: 10, name: "tool_calls_cost", kind: "message", T: () => Money },
            { no: 11, name: "sub_agent_cost", kind: "message", T: () => Money },
            { no: 12, name: "sub_agent_count", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "buf.validate.field": { int32: { gte: 0 } } } }
        ]);
    }
    create(value?: PartialMessage<CostBreakdown>): CostBreakdown {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.llmInputTokens = 0n;
        message.llmOutputTokens = 0n;
        message.cacheReadTokens = 0n;
        message.cacheWriteTokens = 0n;
        message.toolCallsCount = 0;
        message.subAgentCount = 0;
        if (value !== undefined)
            reflectionMergePartial<CostBreakdown>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CostBreakdown): CostBreakdown {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* agency.billing.v1.Money llm_input_tokens_cost */ 1:
                    message.llmInputTokensCost = Money.internalBinaryRead(reader, reader.uint32(), options, message.llmInputTokensCost);
                    break;
                case /* agency.billing.v1.Money llm_output_tokens_cost */ 2:
                    message.llmOutputTokensCost = Money.internalBinaryRead(reader, reader.uint32(), options, message.llmOutputTokensCost);
                    break;
                case /* int64 llm_input_tokens */ 3:
                    message.llmInputTokens = reader.int64().toBigInt();
                    break;
                case /* int64 llm_output_tokens */ 4:
                    message.llmOutputTokens = reader.int64().toBigInt();
                    break;
                case /* int64 cache_read_tokens */ 5:
                    message.cacheReadTokens = reader.int64().toBigInt();
                    break;
                case /* agency.billing.v1.Money cache_read_cost */ 6:
                    message.cacheReadCost = Money.internalBinaryRead(reader, reader.uint32(), options, message.cacheReadCost);
                    break;
                case /* int64 cache_write_tokens */ 7:
                    message.cacheWriteTokens = reader.int64().toBigInt();
                    break;
                case /* agency.billing.v1.Money cache_write_cost */ 8:
                    message.cacheWriteCost = Money.internalBinaryRead(reader, reader.uint32(), options, message.cacheWriteCost);
                    break;
                case /* int32 tool_calls_count */ 9:
                    message.toolCallsCount = reader.int32();
                    break;
                case /* agency.billing.v1.Money tool_calls_cost */ 10:
                    message.toolCallsCost = Money.internalBinaryRead(reader, reader.uint32(), options, message.toolCallsCost);
                    break;
                case /* agency.billing.v1.Money sub_agent_cost */ 11:
                    message.subAgentCost = Money.internalBinaryRead(reader, reader.uint32(), options, message.subAgentCost);
                    break;
                case /* int32 sub_agent_count */ 12:
                    message.subAgentCount = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CostBreakdown, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* agency.billing.v1.Money llm_input_tokens_cost = 1; */
        if (message.llmInputTokensCost)
            Money.internalBinaryWrite(message.llmInputTokensCost, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* agency.billing.v1.Money llm_output_tokens_cost = 2; */
        if (message.llmOutputTokensCost)
            Money.internalBinaryWrite(message.llmOutputTokensCost, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* int64 llm_input_tokens = 3; */
        if (message.llmInputTokens !== 0n)
            writer.tag(3, WireType.Varint).int64(message.llmInputTokens);
        /* int64 llm_output_tokens = 4; */
        if (message.llmOutputTokens !== 0n)
            writer.tag(4, WireType.Varint).int64(message.llmOutputTokens);
        /* int64 cache_read_tokens = 5; */
        if (message.cacheReadTokens !== 0n)
            writer.tag(5, WireType.Varint).int64(message.cacheReadTokens);
        /* agency.billing.v1.Money cache_read_cost = 6; */
        if (message.cacheReadCost)
            Money.internalBinaryWrite(message.cacheReadCost, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* int64 cache_write_tokens = 7; */
        if (message.cacheWriteTokens !== 0n)
            writer.tag(7, WireType.Varint).int64(message.cacheWriteTokens);
        /* agency.billing.v1.Money cache_write_cost = 8; */
        if (message.cacheWriteCost)
            Money.internalBinaryWrite(message.cacheWriteCost, writer.tag(8, WireType.LengthDelimited).fork(), options).join();
        /* int32 tool_calls_count = 9; */
        if (message.toolCallsCount !== 0)
            writer.tag(9, WireType.Varint).int32(message.toolCallsCount);
        /* agency.billing.v1.Money tool_calls_cost = 10; */
        if (message.toolCallsCost)
            Money.internalBinaryWrite(message.toolCallsCost, writer.tag(10, WireType.LengthDelimited).fork(), options).join();
        /* agency.billing.v1.Money sub_agent_cost = 11; */
        if (message.subAgentCost)
            Money.internalBinaryWrite(message.subAgentCost, writer.tag(11, WireType.LengthDelimited).fork(), options).join();
        /* int32 sub_agent_count = 12; */
        if (message.subAgentCount !== 0)
            writer.tag(12, WireType.Varint).int32(message.subAgentCount);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.billing.v1.CostBreakdown
 */
export const CostBreakdown = new CostBreakdown$Type();
// @generated message type with reflection information, may provide speed optimized methods
class BillingEvent$Type extends MessageType<BillingEvent> {
    constructor() {
        super("agency.billing.v1.BillingEvent", [
            { no: 1, name: "tenant", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "64", pattern: "^[a-z0-9][a-z0-9-]*[a-z0-9]$" } } } },
            { no: 2, name: "workspace", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "64", pattern: "^[a-z0-9][a-z0-9-]*[a-z0-9]$" } } } },
            { no: 3, name: "session_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "128", pattern: "^[a-z0-9][a-z0-9-]*[a-z0-9]$" } } } },
            { no: 4, name: "tokens_consumed", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/, options: { "buf.validate.field": { int64: { lte: "10000000", gte: "0" } } } },
            { no: 5, name: "cost", kind: "message", T: () => Money, options: { "buf.validate.field": { required: true } } },
            { no: 6, name: "attribution", kind: "enum", T: () => ["agency.billing.v1.QuotaBillingPolicy", QuotaBillingPolicy, "QUOTA_BILLING_POLICY_"], options: { "buf.validate.field": { enum: { definedOnly: true, notIn: [0] } } } },
            { no: 7, name: "timestamp", kind: "message", T: () => Timestamp, options: { "buf.validate.field": { required: true } } },
            { no: 8, name: "operation_type", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "64", pattern: "^[a-z0-9][a-z0-9_-]*[a-z0-9]$" } } } },
            { no: 9, name: "parent_session_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { maxLen: "128", pattern: "^([a-z0-9][a-z0-9-]*[a-z0-9])?$" } } } },
            { no: 10, name: "initiator_workspace", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { maxLen: "64", pattern: "^([a-z0-9][a-z0-9-]*[a-z0-9])?$" } } } },
            { no: 11, name: "split_config", kind: "message", T: () => QuotaSplitConfig },
            { no: 12, name: "model_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { maxLen: "128" } } } },
            { no: 13, name: "tool_name", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { maxLen: "128", pattern: "^([a-z0-9][a-z0-9_]*[a-z0-9])?$" } } } },
            { no: 14, name: "cost_breakdown", kind: "message", T: () => CostBreakdown }
        ]);
    }
    create(value?: PartialMessage<BillingEvent>): BillingEvent {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.tenant = "";
        message.workspace = "";
        message.sessionId = "";
        message.tokensConsumed = 0n;
        message.attribution = 0;
        message.operationType = "";
        message.parentSessionId = "";
        message.initiatorWorkspace = "";
        message.modelId = "";
        message.toolName = "";
        if (value !== undefined)
            reflectionMergePartial<BillingEvent>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: BillingEvent): BillingEvent {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string tenant */ 1:
                    message.tenant = reader.string();
                    break;
                case /* string workspace */ 2:
                    message.workspace = reader.string();
                    break;
                case /* string session_id */ 3:
                    message.sessionId = reader.string();
                    break;
                case /* int64 tokens_consumed */ 4:
                    message.tokensConsumed = reader.int64().toBigInt();
                    break;
                case /* agency.billing.v1.Money cost */ 5:
                    message.cost = Money.internalBinaryRead(reader, reader.uint32(), options, message.cost);
                    break;
                case /* agency.billing.v1.QuotaBillingPolicy attribution */ 6:
                    message.attribution = reader.int32();
                    break;
                case /* google.protobuf.Timestamp timestamp */ 7:
                    message.timestamp = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.timestamp);
                    break;
                case /* string operation_type */ 8:
                    message.operationType = reader.string();
                    break;
                case /* string parent_session_id */ 9:
                    message.parentSessionId = reader.string();
                    break;
                case /* string initiator_workspace */ 10:
                    message.initiatorWorkspace = reader.string();
                    break;
                case /* agency.billing.v1.QuotaSplitConfig split_config */ 11:
                    message.splitConfig = QuotaSplitConfig.internalBinaryRead(reader, reader.uint32(), options, message.splitConfig);
                    break;
                case /* string model_id */ 12:
                    message.modelId = reader.string();
                    break;
                case /* string tool_name */ 13:
                    message.toolName = reader.string();
                    break;
                case /* agency.billing.v1.CostBreakdown cost_breakdown */ 14:
                    message.costBreakdown = CostBreakdown.internalBinaryRead(reader, reader.uint32(), options, message.costBreakdown);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: BillingEvent, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string tenant = 1; */
        if (message.tenant !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.tenant);
        /* string workspace = 2; */
        if (message.workspace !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.workspace);
        /* string session_id = 3; */
        if (message.sessionId !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.sessionId);
        /* int64 tokens_consumed = 4; */
        if (message.tokensConsumed !== 0n)
            writer.tag(4, WireType.Varint).int64(message.tokensConsumed);
        /* agency.billing.v1.Money cost = 5; */
        if (message.cost)
            Money.internalBinaryWrite(message.cost, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* agency.billing.v1.QuotaBillingPolicy attribution = 6; */
        if (message.attribution !== 0)
            writer.tag(6, WireType.Varint).int32(message.attribution);
        /* google.protobuf.Timestamp timestamp = 7; */
        if (message.timestamp)
            Timestamp.internalBinaryWrite(message.timestamp, writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        /* string operation_type = 8; */
        if (message.operationType !== "")
            writer.tag(8, WireType.LengthDelimited).string(message.operationType);
        /* string parent_session_id = 9; */
        if (message.parentSessionId !== "")
            writer.tag(9, WireType.LengthDelimited).string(message.parentSessionId);
        /* string initiator_workspace = 10; */
        if (message.initiatorWorkspace !== "")
            writer.tag(10, WireType.LengthDelimited).string(message.initiatorWorkspace);
        /* agency.billing.v1.QuotaSplitConfig split_config = 11; */
        if (message.splitConfig)
            QuotaSplitConfig.internalBinaryWrite(message.splitConfig, writer.tag(11, WireType.LengthDelimited).fork(), options).join();
        /* string model_id = 12; */
        if (message.modelId !== "")
            writer.tag(12, WireType.LengthDelimited).string(message.modelId);
        /* string tool_name = 13; */
        if (message.toolName !== "")
            writer.tag(13, WireType.LengthDelimited).string(message.toolName);
        /* agency.billing.v1.CostBreakdown cost_breakdown = 14; */
        if (message.costBreakdown)
            CostBreakdown.internalBinaryWrite(message.costBreakdown, writer.tag(14, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.billing.v1.BillingEvent
 */
export const BillingEvent = new BillingEvent$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TierConfig$Type extends MessageType<TierConfig> {
    constructor() {
        super("agency.billing.v1.TierConfig", [
            { no: 1, name: "tier_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "64", pattern: "^[a-z0-9][a-z0-9_-]*[a-z0-9]$" } } } },
            { no: 2, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "128" } } } },
            { no: 3, name: "token_limit", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/, options: { "buf.validate.field": { int64: { gte: "0" } } } },
            { no: 4, name: "refill_rate", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/, options: { "buf.validate.field": { int64: { gte: "0" } } } },
            { no: 5, name: "price_per_million_tokens", kind: "message", T: () => Money, options: { "buf.validate.field": { required: true } } },
            { no: 6, name: "billing_policy", kind: "enum", T: () => ["agency.billing.v1.QuotaBillingPolicy", QuotaBillingPolicy, "QUOTA_BILLING_POLICY_"], options: { "buf.validate.field": { enum: { definedOnly: true, notIn: [0] } } } },
            { no: 7, name: "features", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { repeated: { maxItems: "50", items: { string: { minLen: "1", maxLen: "128", pattern: "^[a-z0-9][a-z0-9_-]*[a-z0-9]$" } } } } } },
            { no: 8, name: "max_concurrent_sessions", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "buf.validate.field": { int32: { lte: 10000, gte: 0 } } } },
            { no: 9, name: "max_session_duration_seconds", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "buf.validate.field": { int32: { lte: 86400, gte: 0 } } } }
        ]);
    }
    create(value?: PartialMessage<TierConfig>): TierConfig {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.tierId = "";
        message.name = "";
        message.tokenLimit = 0n;
        message.refillRate = 0n;
        message.billingPolicy = 0;
        message.features = [];
        message.maxConcurrentSessions = 0;
        message.maxSessionDurationSeconds = 0;
        if (value !== undefined)
            reflectionMergePartial<TierConfig>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: TierConfig): TierConfig {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string tier_id */ 1:
                    message.tierId = reader.string();
                    break;
                case /* string name */ 2:
                    message.name = reader.string();
                    break;
                case /* int64 token_limit */ 3:
                    message.tokenLimit = reader.int64().toBigInt();
                    break;
                case /* int64 refill_rate */ 4:
                    message.refillRate = reader.int64().toBigInt();
                    break;
                case /* agency.billing.v1.Money price_per_million_tokens */ 5:
                    message.pricePerMillionTokens = Money.internalBinaryRead(reader, reader.uint32(), options, message.pricePerMillionTokens);
                    break;
                case /* agency.billing.v1.QuotaBillingPolicy billing_policy */ 6:
                    message.billingPolicy = reader.int32();
                    break;
                case /* repeated string features */ 7:
                    message.features.push(reader.string());
                    break;
                case /* int32 max_concurrent_sessions */ 8:
                    message.maxConcurrentSessions = reader.int32();
                    break;
                case /* int32 max_session_duration_seconds */ 9:
                    message.maxSessionDurationSeconds = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: TierConfig, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string tier_id = 1; */
        if (message.tierId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.tierId);
        /* string name = 2; */
        if (message.name !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.name);
        /* int64 token_limit = 3; */
        if (message.tokenLimit !== 0n)
            writer.tag(3, WireType.Varint).int64(message.tokenLimit);
        /* int64 refill_rate = 4; */
        if (message.refillRate !== 0n)
            writer.tag(4, WireType.Varint).int64(message.refillRate);
        /* agency.billing.v1.Money price_per_million_tokens = 5; */
        if (message.pricePerMillionTokens)
            Money.internalBinaryWrite(message.pricePerMillionTokens, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* agency.billing.v1.QuotaBillingPolicy billing_policy = 6; */
        if (message.billingPolicy !== 0)
            writer.tag(6, WireType.Varint).int32(message.billingPolicy);
        /* repeated string features = 7; */
        for (let i = 0; i < message.features.length; i++)
            writer.tag(7, WireType.LengthDelimited).string(message.features[i]);
        /* int32 max_concurrent_sessions = 8; */
        if (message.maxConcurrentSessions !== 0)
            writer.tag(8, WireType.Varint).int32(message.maxConcurrentSessions);
        /* int32 max_session_duration_seconds = 9; */
        if (message.maxSessionDurationSeconds !== 0)
            writer.tag(9, WireType.Varint).int32(message.maxSessionDurationSeconds);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.billing.v1.TierConfig
 */
export const TierConfig = new TierConfig$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SessionSpend$Type extends MessageType<SessionSpend> {
    constructor() {
        super("agency.billing.v1.SessionSpend", [
            { no: 1, name: "session_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "128", pattern: "^[a-z0-9][a-z0-9-]*[a-z0-9]$" } } } },
            { no: 2, name: "tenant", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "64", pattern: "^[a-z0-9][a-z0-9-]*[a-z0-9]$" } } } },
            { no: 3, name: "workspace", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "64", pattern: "^[a-z0-9][a-z0-9-]*[a-z0-9]$" } } } },
            { no: 4, name: "tokens_consumed", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/, options: { "buf.validate.field": { int64: { gte: "0" } } } },
            { no: 5, name: "tool_calls", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "buf.validate.field": { int32: { gte: 0 } } } },
            { no: 6, name: "llm_calls", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "buf.validate.field": { int32: { gte: 0 } } } },
            { no: 7, name: "estimated_cost", kind: "message", T: () => Money, options: { "buf.validate.field": { required: true } } },
            { no: 8, name: "updated_at", kind: "message", T: () => Timestamp, options: { "buf.validate.field": { required: true } } },
            { no: 9, name: "started_at", kind: "message", T: () => Timestamp, options: { "buf.validate.field": { required: true } } },
            { no: 10, name: "completed_at", kind: "message", T: () => Timestamp }
        ]);
    }
    create(value?: PartialMessage<SessionSpend>): SessionSpend {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.sessionId = "";
        message.tenant = "";
        message.workspace = "";
        message.tokensConsumed = 0n;
        message.toolCalls = 0;
        message.llmCalls = 0;
        if (value !== undefined)
            reflectionMergePartial<SessionSpend>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SessionSpend): SessionSpend {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string session_id */ 1:
                    message.sessionId = reader.string();
                    break;
                case /* string tenant */ 2:
                    message.tenant = reader.string();
                    break;
                case /* string workspace */ 3:
                    message.workspace = reader.string();
                    break;
                case /* int64 tokens_consumed */ 4:
                    message.tokensConsumed = reader.int64().toBigInt();
                    break;
                case /* int32 tool_calls */ 5:
                    message.toolCalls = reader.int32();
                    break;
                case /* int32 llm_calls */ 6:
                    message.llmCalls = reader.int32();
                    break;
                case /* agency.billing.v1.Money estimated_cost */ 7:
                    message.estimatedCost = Money.internalBinaryRead(reader, reader.uint32(), options, message.estimatedCost);
                    break;
                case /* google.protobuf.Timestamp updated_at */ 8:
                    message.updatedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.updatedAt);
                    break;
                case /* google.protobuf.Timestamp started_at */ 9:
                    message.startedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.startedAt);
                    break;
                case /* google.protobuf.Timestamp completed_at */ 10:
                    message.completedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.completedAt);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SessionSpend, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string session_id = 1; */
        if (message.sessionId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.sessionId);
        /* string tenant = 2; */
        if (message.tenant !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.tenant);
        /* string workspace = 3; */
        if (message.workspace !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.workspace);
        /* int64 tokens_consumed = 4; */
        if (message.tokensConsumed !== 0n)
            writer.tag(4, WireType.Varint).int64(message.tokensConsumed);
        /* int32 tool_calls = 5; */
        if (message.toolCalls !== 0)
            writer.tag(5, WireType.Varint).int32(message.toolCalls);
        /* int32 llm_calls = 6; */
        if (message.llmCalls !== 0)
            writer.tag(6, WireType.Varint).int32(message.llmCalls);
        /* agency.billing.v1.Money estimated_cost = 7; */
        if (message.estimatedCost)
            Money.internalBinaryWrite(message.estimatedCost, writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp updated_at = 8; */
        if (message.updatedAt)
            Timestamp.internalBinaryWrite(message.updatedAt, writer.tag(8, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp started_at = 9; */
        if (message.startedAt)
            Timestamp.internalBinaryWrite(message.startedAt, writer.tag(9, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp completed_at = 10; */
        if (message.completedAt)
            Timestamp.internalBinaryWrite(message.completedAt, writer.tag(10, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.billing.v1.SessionSpend
 */
export const SessionSpend = new SessionSpend$Type();
// @generated message type with reflection information, may provide speed optimized methods
class WorkspaceUsageAggregate$Type extends MessageType<WorkspaceUsageAggregate> {
    constructor() {
        super("agency.billing.v1.WorkspaceUsageAggregate", [
            { no: 1, name: "tenant", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "64", pattern: "^[a-z0-9][a-z0-9-]*[a-z0-9]$" } } } },
            { no: 2, name: "workspace", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "64", pattern: "^[a-z0-9][a-z0-9-]*[a-z0-9]$" } } } },
            { no: 3, name: "period_start", kind: "message", T: () => Timestamp, options: { "buf.validate.field": { required: true } } },
            { no: 4, name: "period_end", kind: "message", T: () => Timestamp, options: { "buf.validate.field": { required: true } } },
            { no: 5, name: "total_tokens", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/, options: { "buf.validate.field": { int64: { gte: "0" } } } },
            { no: 6, name: "total_sessions", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "buf.validate.field": { int32: { gte: 0 } } } },
            { no: 7, name: "total_tool_calls", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "buf.validate.field": { int32: { gte: 0 } } } },
            { no: 8, name: "total_cost", kind: "message", T: () => Money, options: { "buf.validate.field": { required: true } } },
            { no: 9, name: "updated_at", kind: "message", T: () => Timestamp, options: { "buf.validate.field": { required: true } } }
        ]);
    }
    create(value?: PartialMessage<WorkspaceUsageAggregate>): WorkspaceUsageAggregate {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.tenant = "";
        message.workspace = "";
        message.totalTokens = 0n;
        message.totalSessions = 0;
        message.totalToolCalls = 0;
        if (value !== undefined)
            reflectionMergePartial<WorkspaceUsageAggregate>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: WorkspaceUsageAggregate): WorkspaceUsageAggregate {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string tenant */ 1:
                    message.tenant = reader.string();
                    break;
                case /* string workspace */ 2:
                    message.workspace = reader.string();
                    break;
                case /* google.protobuf.Timestamp period_start */ 3:
                    message.periodStart = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.periodStart);
                    break;
                case /* google.protobuf.Timestamp period_end */ 4:
                    message.periodEnd = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.periodEnd);
                    break;
                case /* int64 total_tokens */ 5:
                    message.totalTokens = reader.int64().toBigInt();
                    break;
                case /* int32 total_sessions */ 6:
                    message.totalSessions = reader.int32();
                    break;
                case /* int32 total_tool_calls */ 7:
                    message.totalToolCalls = reader.int32();
                    break;
                case /* agency.billing.v1.Money total_cost */ 8:
                    message.totalCost = Money.internalBinaryRead(reader, reader.uint32(), options, message.totalCost);
                    break;
                case /* google.protobuf.Timestamp updated_at */ 9:
                    message.updatedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.updatedAt);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: WorkspaceUsageAggregate, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string tenant = 1; */
        if (message.tenant !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.tenant);
        /* string workspace = 2; */
        if (message.workspace !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.workspace);
        /* google.protobuf.Timestamp period_start = 3; */
        if (message.periodStart)
            Timestamp.internalBinaryWrite(message.periodStart, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp period_end = 4; */
        if (message.periodEnd)
            Timestamp.internalBinaryWrite(message.periodEnd, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* int64 total_tokens = 5; */
        if (message.totalTokens !== 0n)
            writer.tag(5, WireType.Varint).int64(message.totalTokens);
        /* int32 total_sessions = 6; */
        if (message.totalSessions !== 0)
            writer.tag(6, WireType.Varint).int32(message.totalSessions);
        /* int32 total_tool_calls = 7; */
        if (message.totalToolCalls !== 0)
            writer.tag(7, WireType.Varint).int32(message.totalToolCalls);
        /* agency.billing.v1.Money total_cost = 8; */
        if (message.totalCost)
            Money.internalBinaryWrite(message.totalCost, writer.tag(8, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp updated_at = 9; */
        if (message.updatedAt)
            Timestamp.internalBinaryWrite(message.updatedAt, writer.tag(9, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.billing.v1.WorkspaceUsageAggregate
 */
export const WorkspaceUsageAggregate = new WorkspaceUsageAggregate$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TenantUsageAggregate$Type extends MessageType<TenantUsageAggregate> {
    constructor() {
        super("agency.billing.v1.TenantUsageAggregate", [
            { no: 1, name: "tenant", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "64", pattern: "^[a-z0-9][a-z0-9-]*[a-z0-9]$" } } } },
            { no: 2, name: "period_start", kind: "message", T: () => Timestamp, options: { "buf.validate.field": { required: true } } },
            { no: 3, name: "period_end", kind: "message", T: () => Timestamp, options: { "buf.validate.field": { required: true } } },
            { no: 4, name: "total_tokens", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/, options: { "buf.validate.field": { int64: { gte: "0" } } } },
            { no: 5, name: "total_workspaces", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "buf.validate.field": { int32: { gte: 0 } } } },
            { no: 6, name: "total_sessions", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "buf.validate.field": { int32: { gte: 0 } } } },
            { no: 7, name: "total_cost", kind: "message", T: () => Money, options: { "buf.validate.field": { required: true } } },
            { no: 8, name: "updated_at", kind: "message", T: () => Timestamp, options: { "buf.validate.field": { required: true } } }
        ]);
    }
    create(value?: PartialMessage<TenantUsageAggregate>): TenantUsageAggregate {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.tenant = "";
        message.totalTokens = 0n;
        message.totalWorkspaces = 0;
        message.totalSessions = 0;
        if (value !== undefined)
            reflectionMergePartial<TenantUsageAggregate>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: TenantUsageAggregate): TenantUsageAggregate {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string tenant */ 1:
                    message.tenant = reader.string();
                    break;
                case /* google.protobuf.Timestamp period_start */ 2:
                    message.periodStart = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.periodStart);
                    break;
                case /* google.protobuf.Timestamp period_end */ 3:
                    message.periodEnd = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.periodEnd);
                    break;
                case /* int64 total_tokens */ 4:
                    message.totalTokens = reader.int64().toBigInt();
                    break;
                case /* int32 total_workspaces */ 5:
                    message.totalWorkspaces = reader.int32();
                    break;
                case /* int32 total_sessions */ 6:
                    message.totalSessions = reader.int32();
                    break;
                case /* agency.billing.v1.Money total_cost */ 7:
                    message.totalCost = Money.internalBinaryRead(reader, reader.uint32(), options, message.totalCost);
                    break;
                case /* google.protobuf.Timestamp updated_at */ 8:
                    message.updatedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.updatedAt);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: TenantUsageAggregate, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string tenant = 1; */
        if (message.tenant !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.tenant);
        /* google.protobuf.Timestamp period_start = 2; */
        if (message.periodStart)
            Timestamp.internalBinaryWrite(message.periodStart, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp period_end = 3; */
        if (message.periodEnd)
            Timestamp.internalBinaryWrite(message.periodEnd, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* int64 total_tokens = 4; */
        if (message.totalTokens !== 0n)
            writer.tag(4, WireType.Varint).int64(message.totalTokens);
        /* int32 total_workspaces = 5; */
        if (message.totalWorkspaces !== 0)
            writer.tag(5, WireType.Varint).int32(message.totalWorkspaces);
        /* int32 total_sessions = 6; */
        if (message.totalSessions !== 0)
            writer.tag(6, WireType.Varint).int32(message.totalSessions);
        /* agency.billing.v1.Money total_cost = 7; */
        if (message.totalCost)
            Money.internalBinaryWrite(message.totalCost, writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp updated_at = 8; */
        if (message.updatedAt)
            Timestamp.internalBinaryWrite(message.updatedAt, writer.tag(8, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.billing.v1.TenantUsageAggregate
 */
export const TenantUsageAggregate = new TenantUsageAggregate$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UsageRollup$Type extends MessageType<UsageRollup> {
    constructor() {
        super("agency.billing.v1.UsageRollup", [
            { no: 1, name: "tenant", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "64", pattern: "^[a-z0-9][a-z0-9-]*[a-z0-9]$" } } } },
            { no: 2, name: "workspace", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "64", pattern: "^[a-z0-9][a-z0-9-]*[a-z0-9]$" } } } },
            { no: 3, name: "session_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { maxLen: "128", pattern: "^([a-z0-9][a-z0-9-]*[a-z0-9])?$" } } } },
            { no: 4, name: "rollup_level", kind: "enum", T: () => ["agency.billing.v1.RollupLevel", RollupLevel, "ROLLUP_LEVEL_"], options: { "buf.validate.field": { enum: { definedOnly: true, notIn: [0] } } } },
            { no: 5, name: "token_delta", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/, options: { "buf.validate.field": { int64: { gte: "0" } } } },
            { no: 6, name: "cost_delta", kind: "message", T: () => Money, options: { "buf.validate.field": { required: true } } },
            { no: 7, name: "operation_count", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "buf.validate.field": { int32: { gte: 0 } } } },
            { no: 8, name: "period_start", kind: "message", T: () => Timestamp, options: { "buf.validate.field": { required: true } } },
            { no: 9, name: "period_end", kind: "message", T: () => Timestamp, options: { "buf.validate.field": { required: true } } },
            { no: 10, name: "cost_breakdown", kind: "message", T: () => CostBreakdown }
        ]);
    }
    create(value?: PartialMessage<UsageRollup>): UsageRollup {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.tenant = "";
        message.workspace = "";
        message.sessionId = "";
        message.rollupLevel = 0;
        message.tokenDelta = 0n;
        message.operationCount = 0;
        if (value !== undefined)
            reflectionMergePartial<UsageRollup>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UsageRollup): UsageRollup {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string tenant */ 1:
                    message.tenant = reader.string();
                    break;
                case /* string workspace */ 2:
                    message.workspace = reader.string();
                    break;
                case /* string session_id */ 3:
                    message.sessionId = reader.string();
                    break;
                case /* agency.billing.v1.RollupLevel rollup_level */ 4:
                    message.rollupLevel = reader.int32();
                    break;
                case /* int64 token_delta */ 5:
                    message.tokenDelta = reader.int64().toBigInt();
                    break;
                case /* agency.billing.v1.Money cost_delta */ 6:
                    message.costDelta = Money.internalBinaryRead(reader, reader.uint32(), options, message.costDelta);
                    break;
                case /* int32 operation_count */ 7:
                    message.operationCount = reader.int32();
                    break;
                case /* google.protobuf.Timestamp period_start */ 8:
                    message.periodStart = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.periodStart);
                    break;
                case /* google.protobuf.Timestamp period_end */ 9:
                    message.periodEnd = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.periodEnd);
                    break;
                case /* agency.billing.v1.CostBreakdown cost_breakdown */ 10:
                    message.costBreakdown = CostBreakdown.internalBinaryRead(reader, reader.uint32(), options, message.costBreakdown);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UsageRollup, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string tenant = 1; */
        if (message.tenant !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.tenant);
        /* string workspace = 2; */
        if (message.workspace !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.workspace);
        /* string session_id = 3; */
        if (message.sessionId !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.sessionId);
        /* agency.billing.v1.RollupLevel rollup_level = 4; */
        if (message.rollupLevel !== 0)
            writer.tag(4, WireType.Varint).int32(message.rollupLevel);
        /* int64 token_delta = 5; */
        if (message.tokenDelta !== 0n)
            writer.tag(5, WireType.Varint).int64(message.tokenDelta);
        /* agency.billing.v1.Money cost_delta = 6; */
        if (message.costDelta)
            Money.internalBinaryWrite(message.costDelta, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* int32 operation_count = 7; */
        if (message.operationCount !== 0)
            writer.tag(7, WireType.Varint).int32(message.operationCount);
        /* google.protobuf.Timestamp period_start = 8; */
        if (message.periodStart)
            Timestamp.internalBinaryWrite(message.periodStart, writer.tag(8, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp period_end = 9; */
        if (message.periodEnd)
            Timestamp.internalBinaryWrite(message.periodEnd, writer.tag(9, WireType.LengthDelimited).fork(), options).join();
        /* agency.billing.v1.CostBreakdown cost_breakdown = 10; */
        if (message.costBreakdown)
            CostBreakdown.internalBinaryWrite(message.costBreakdown, writer.tag(10, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.billing.v1.UsageRollup
 */
export const UsageRollup = new UsageRollup$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TierResolutionRequest$Type extends MessageType<TierResolutionRequest> {
    constructor() {
        super("agency.billing.v1.TierResolutionRequest", [
            { no: 1, name: "tenant", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "64", pattern: "^[a-z0-9][a-z0-9-]*[a-z0-9]$" } } } },
            { no: 2, name: "workspace", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { maxLen: "64", pattern: "^([a-z0-9][a-z0-9-]*[a-z0-9])?$" } } } }
        ]);
    }
    create(value?: PartialMessage<TierResolutionRequest>): TierResolutionRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.tenant = "";
        message.workspace = "";
        if (value !== undefined)
            reflectionMergePartial<TierResolutionRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: TierResolutionRequest): TierResolutionRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string tenant */ 1:
                    message.tenant = reader.string();
                    break;
                case /* string workspace */ 2:
                    message.workspace = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: TierResolutionRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string tenant = 1; */
        if (message.tenant !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.tenant);
        /* string workspace = 2; */
        if (message.workspace !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.workspace);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.billing.v1.TierResolutionRequest
 */
export const TierResolutionRequest = new TierResolutionRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TierResolutionResponse$Type extends MessageType<TierResolutionResponse> {
    constructor() {
        super("agency.billing.v1.TierResolutionResponse", [
            { no: 1, name: "tier_config", kind: "message", T: () => TierConfig, options: { "buf.validate.field": { required: true } } },
            { no: 2, name: "tenant", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "64", pattern: "^[a-z0-9][a-z0-9-]*[a-z0-9]$" } } } },
            { no: 3, name: "resolved_at", kind: "message", T: () => Timestamp, options: { "buf.validate.field": { required: true } } }
        ]);
    }
    create(value?: PartialMessage<TierResolutionResponse>): TierResolutionResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.tenant = "";
        if (value !== undefined)
            reflectionMergePartial<TierResolutionResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: TierResolutionResponse): TierResolutionResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* agency.billing.v1.TierConfig tier_config */ 1:
                    message.tierConfig = TierConfig.internalBinaryRead(reader, reader.uint32(), options, message.tierConfig);
                    break;
                case /* string tenant */ 2:
                    message.tenant = reader.string();
                    break;
                case /* google.protobuf.Timestamp resolved_at */ 3:
                    message.resolvedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.resolvedAt);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: TierResolutionResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* agency.billing.v1.TierConfig tier_config = 1; */
        if (message.tierConfig)
            TierConfig.internalBinaryWrite(message.tierConfig, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string tenant = 2; */
        if (message.tenant !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.tenant);
        /* google.protobuf.Timestamp resolved_at = 3; */
        if (message.resolvedAt)
            Timestamp.internalBinaryWrite(message.resolvedAt, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.billing.v1.TierResolutionResponse
 */
export const TierResolutionResponse = new TierResolutionResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CostAttributionRequest$Type extends MessageType<CostAttributionRequest> {
    constructor() {
        super("agency.billing.v1.CostAttributionRequest", [
            { no: 1, name: "session_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "128", pattern: "^[a-z0-9][a-z0-9-]*[a-z0-9]$" } } } },
            { no: 2, name: "parent_session_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { maxLen: "128", pattern: "^([a-z0-9][a-z0-9-]*[a-z0-9])?$" } } } },
            { no: 3, name: "initiator_tenant", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "64", pattern: "^[a-z0-9][a-z0-9-]*[a-z0-9]$" } } } },
            { no: 4, name: "initiator_workspace", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "64", pattern: "^[a-z0-9][a-z0-9-]*[a-z0-9]$" } } } },
            { no: 5, name: "delegate_tenant", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "64", pattern: "^[a-z0-9][a-z0-9-]*[a-z0-9]$" } } } },
            { no: 6, name: "delegate_workspace", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "64", pattern: "^[a-z0-9][a-z0-9-]*[a-z0-9]$" } } } },
            { no: 7, name: "billing_policy", kind: "enum", T: () => ["agency.billing.v1.QuotaBillingPolicy", QuotaBillingPolicy, "QUOTA_BILLING_POLICY_"], options: { "buf.validate.field": { enum: { definedOnly: true, notIn: [0] } } } },
            { no: 8, name: "split_config", kind: "message", T: () => QuotaSplitConfig },
            { no: 9, name: "cost", kind: "message", T: () => Money, options: { "buf.validate.field": { required: true } } },
            { no: 10, name: "tokens_consumed", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/, options: { "buf.validate.field": { int64: { gte: "0" } } } },
            { no: 11, name: "cost_breakdown", kind: "message", T: () => CostBreakdown }
        ]);
    }
    create(value?: PartialMessage<CostAttributionRequest>): CostAttributionRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.sessionId = "";
        message.parentSessionId = "";
        message.initiatorTenant = "";
        message.initiatorWorkspace = "";
        message.delegateTenant = "";
        message.delegateWorkspace = "";
        message.billingPolicy = 0;
        message.tokensConsumed = 0n;
        if (value !== undefined)
            reflectionMergePartial<CostAttributionRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CostAttributionRequest): CostAttributionRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string session_id */ 1:
                    message.sessionId = reader.string();
                    break;
                case /* string parent_session_id */ 2:
                    message.parentSessionId = reader.string();
                    break;
                case /* string initiator_tenant */ 3:
                    message.initiatorTenant = reader.string();
                    break;
                case /* string initiator_workspace */ 4:
                    message.initiatorWorkspace = reader.string();
                    break;
                case /* string delegate_tenant */ 5:
                    message.delegateTenant = reader.string();
                    break;
                case /* string delegate_workspace */ 6:
                    message.delegateWorkspace = reader.string();
                    break;
                case /* agency.billing.v1.QuotaBillingPolicy billing_policy */ 7:
                    message.billingPolicy = reader.int32();
                    break;
                case /* agency.billing.v1.QuotaSplitConfig split_config */ 8:
                    message.splitConfig = QuotaSplitConfig.internalBinaryRead(reader, reader.uint32(), options, message.splitConfig);
                    break;
                case /* agency.billing.v1.Money cost */ 9:
                    message.cost = Money.internalBinaryRead(reader, reader.uint32(), options, message.cost);
                    break;
                case /* int64 tokens_consumed */ 10:
                    message.tokensConsumed = reader.int64().toBigInt();
                    break;
                case /* agency.billing.v1.CostBreakdown cost_breakdown */ 11:
                    message.costBreakdown = CostBreakdown.internalBinaryRead(reader, reader.uint32(), options, message.costBreakdown);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CostAttributionRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string session_id = 1; */
        if (message.sessionId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.sessionId);
        /* string parent_session_id = 2; */
        if (message.parentSessionId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.parentSessionId);
        /* string initiator_tenant = 3; */
        if (message.initiatorTenant !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.initiatorTenant);
        /* string initiator_workspace = 4; */
        if (message.initiatorWorkspace !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.initiatorWorkspace);
        /* string delegate_tenant = 5; */
        if (message.delegateTenant !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.delegateTenant);
        /* string delegate_workspace = 6; */
        if (message.delegateWorkspace !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.delegateWorkspace);
        /* agency.billing.v1.QuotaBillingPolicy billing_policy = 7; */
        if (message.billingPolicy !== 0)
            writer.tag(7, WireType.Varint).int32(message.billingPolicy);
        /* agency.billing.v1.QuotaSplitConfig split_config = 8; */
        if (message.splitConfig)
            QuotaSplitConfig.internalBinaryWrite(message.splitConfig, writer.tag(8, WireType.LengthDelimited).fork(), options).join();
        /* agency.billing.v1.Money cost = 9; */
        if (message.cost)
            Money.internalBinaryWrite(message.cost, writer.tag(9, WireType.LengthDelimited).fork(), options).join();
        /* int64 tokens_consumed = 10; */
        if (message.tokensConsumed !== 0n)
            writer.tag(10, WireType.Varint).int64(message.tokensConsumed);
        /* agency.billing.v1.CostBreakdown cost_breakdown = 11; */
        if (message.costBreakdown)
            CostBreakdown.internalBinaryWrite(message.costBreakdown, writer.tag(11, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.billing.v1.CostAttributionRequest
 */
export const CostAttributionRequest = new CostAttributionRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CostAttributionResponse$Type extends MessageType<CostAttributionResponse> {
    constructor() {
        super("agency.billing.v1.CostAttributionResponse", [
            { no: 1, name: "attributed_events", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => BillingEvent, options: { "buf.validate.field": { repeated: { minItems: "1", maxItems: "10" } } } },
            { no: 2, name: "initiator_cost", kind: "message", T: () => Money, options: { "buf.validate.field": { required: true } } },
            { no: 3, name: "delegate_cost", kind: "message", T: () => Money, options: { "buf.validate.field": { required: true } } },
            { no: 4, name: "policy_applied", kind: "enum", T: () => ["agency.billing.v1.QuotaBillingPolicy", QuotaBillingPolicy, "QUOTA_BILLING_POLICY_"], options: { "buf.validate.field": { enum: { definedOnly: true, notIn: [0] } } } },
            { no: 5, name: "attributed_at", kind: "message", T: () => Timestamp, options: { "buf.validate.field": { required: true } } }
        ]);
    }
    create(value?: PartialMessage<CostAttributionResponse>): CostAttributionResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.attributedEvents = [];
        message.policyApplied = 0;
        if (value !== undefined)
            reflectionMergePartial<CostAttributionResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CostAttributionResponse): CostAttributionResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated agency.billing.v1.BillingEvent attributed_events */ 1:
                    message.attributedEvents.push(BillingEvent.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* agency.billing.v1.Money initiator_cost */ 2:
                    message.initiatorCost = Money.internalBinaryRead(reader, reader.uint32(), options, message.initiatorCost);
                    break;
                case /* agency.billing.v1.Money delegate_cost */ 3:
                    message.delegateCost = Money.internalBinaryRead(reader, reader.uint32(), options, message.delegateCost);
                    break;
                case /* agency.billing.v1.QuotaBillingPolicy policy_applied */ 4:
                    message.policyApplied = reader.int32();
                    break;
                case /* google.protobuf.Timestamp attributed_at */ 5:
                    message.attributedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.attributedAt);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CostAttributionResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated agency.billing.v1.BillingEvent attributed_events = 1; */
        for (let i = 0; i < message.attributedEvents.length; i++)
            BillingEvent.internalBinaryWrite(message.attributedEvents[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* agency.billing.v1.Money initiator_cost = 2; */
        if (message.initiatorCost)
            Money.internalBinaryWrite(message.initiatorCost, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* agency.billing.v1.Money delegate_cost = 3; */
        if (message.delegateCost)
            Money.internalBinaryWrite(message.delegateCost, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* agency.billing.v1.QuotaBillingPolicy policy_applied = 4; */
        if (message.policyApplied !== 0)
            writer.tag(4, WireType.Varint).int32(message.policyApplied);
        /* google.protobuf.Timestamp attributed_at = 5; */
        if (message.attributedAt)
            Timestamp.internalBinaryWrite(message.attributedAt, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.billing.v1.CostAttributionResponse
 */
export const CostAttributionResponse = new CostAttributionResponse$Type();
